module.exports = __webpack_public_path__ + "static/media/jd_mobile_cover_video.a2cc9932.mp4";